import jsPDF from "jspdf";
import { font, fontBold } from "@/assets/fonts/Sarabun-normal.js";

export default {
    methods: {
        async generatePdf() {
            try {
                this.isDisableDownloadReportBtn = true;

                let pdf = new jsPDF(this.pdfOption);

                const pdf_width = pdf.internal.pageSize.width;
                const pdf_height = pdf.internal.pageSize.height;

                const margin_l = this.pdfConfig.margin.l;
                const margin_t = this.pdfConfig.margin.t;
                const margin_b = this.pdfConfig.margin.b;

                let cellHeight = 25;

                const addNewPageIfNeeded = (incrementValue) => {
                    if ((pdf_position_y + incrementValue) >= pdf_height - margin_t) {
                        pdf.addPage();
                        pdf_position_y = margin_t; // Reset the position to the top of the new page
                    } else {
                        pdf_position_y += incrementValue; // Add the input value
                    }
                };

                let pdf_position_y = 0;
                pdf.addFileToVFS("Sarabun-Regular.ttf", fontBold);
                pdf.addFont("Sarabun-Regular.ttf", "Sarabun", "bold");
                pdf.addFileToVFS("Sarabun-Regular.ttf", font);
                pdf.addFont("Sarabun-Regular.ttf", "Sarabun", "normal");

                pdf_position_y += margin_t;

                pdf.setFont("Sarabun", "bold");
                pdf.setFontSize(this.pdfConfig.typo.header);
                this.thaitext(
                    pdf,
                    "รายงานเพื่อจัดส่งหนังสือ",
                    pdf_width / 2,
                    pdf_position_y,
                    0,
                    "center"
                );
                addNewPageIfNeeded(this.pdfConfig.endRow);

                pdf.setFont("Sarabun", "normal");
                pdf.setFontSize(this.pdfConfig.typo.extraSmall);

                this.thaitext(
                    pdf,
                    "วันที่พิมพ์ : " + ' ' + this.formatDateToThai(this.moment().format("YYYY-MM-DD"), false),
                    pdf_width - 20,
                    pdf_position_y,
                    0,
                    "right"
                );
                addNewPageIfNeeded(this.pdfConfig.endNormal);

                this.thaitext(
                    pdf,
                    "ผู้พิมพ์ข้อมูล : " + ' ' + (this.currentProfile ? this.currentProfile.fullName : '-'),
                    pdf_width - 20,
                    pdf_position_y,
                    0,
                    "right"
                );
                addNewPageIfNeeded(this.pdfConfig.endRow);

                let hasPurchaseDate = this.paymentDate.start ? true : false
                let startDate = this.moment(this.paymentDate.start).format("YYYY-MM-DD");
                let endDate = this.moment(this.paymentDate.end).format("YYYY-MM-DD");
                this.thaitext(
                    pdf,
                    "วันที่ชำระเงิน : " + ' ' + (hasPurchaseDate ? this.formatDateToThai(startDate, false) + ' - ' + this.formatDateToThai(endDate, false) : '-'),
                    margin_l,
                    pdf_position_y
                );
                addNewPageIfNeeded(this.pdfConfig.endNormal);

                this.thaitext(
                    pdf,
                    "สถาบัน : " + this.instituteName,
                    margin_l,
                    pdf_position_y
                );
                addNewPageIfNeeded(this.pdfConfig.endNormal);

                const tableHeader = ["ลำดับ", "รหัสนักเรียน\n(Ref1)", "ชื่อนักเรียน", "เบอร์โทร", "อายุ\n(ปี)", "สถานะการ\nยืนยันตัวตน", "จัดส่งที่", "รหัสไปรษณีย์", "รหัสหนังสือ", "รหัสชำระ\nเงิน (Ref2)", "วันที่ชำระ\nเงิน", "ช่องทาง\nชำระ", "จำนวนเงิน\n(บาท)"];
                const colWidths = [20, 40, 80, 45, 20, 40, 90, 40, 50, 40, 45, 40, 40];
                let headerX = 20;
                pdf.setLineWidth(0.1);
                pdf.setFont("Sarabun", "bold");

                const fontSize = pdf.getFontSize();
                const fontHeight = fontSize * 0.3528;
                const lineSpacing = 5; // Extra padding between multiline texts

                const renderTableHeader = () => {
                    pdf.setFont("Sarabun", "bold");

                    for (let i = 0; i < tableHeader.length; i++) {
                        const width = colWidths[i];

                        // 1. Draw Header Cell Border
                        pdf.rect(headerX, pdf_position_y, width, cellHeight);

                        // 2. Split text by newline for multiline support
                        const lines = tableHeader[i].split('\n');
                        const totalLines = lines.length;

                        // Calculate the starting Y position so the entire block of text is vertically centered
                        const totalTextHeight = (totalLines * fontHeight) + ((totalLines - 1) * lineSpacing);
                        let startY = pdf_position_y + (cellHeight - totalTextHeight) / 2 + fontHeight;

                        // 3. Loop through and center each individual line
                        for (let j = 0; j < totalLines; j++) {
                            const lineText = lines[j];

                            // Calculate horizontal center for the current line
                            const textWidth = pdf.getStringUnitWidth(lineText) * fontSize / pdf.internal.scaleFactor;
                            const textX = headerX + (width - textWidth) / 2;

                            // Render the text using your custom Thai text function
                            this.thaitext(pdf, lineText, textX, startY);

                            // Move Y down for the next line
                            startY += fontHeight + lineSpacing;
                        }

                        headerX += width;
                    }
                    pdf_position_y += cellHeight;

                    pdf.setFont("Sarabun", "normal");
                    cellHeight = 20
                }

                // Create table header
                renderTableHeader();

                const maxPrintableY = pdf_height - margin_b;
                let finalRowHeight = Math.max(cellHeight);

                const calculateAge = (dob) => {
                    if (!dob) return '-';

                    const birthDate = new Date(dob);
                    const today = new Date();

                    let age = today.getFullYear() - birthDate.getFullYear();
                    const monthDifference = today.getMonth() - birthDate.getMonth();

                    // Adjust age if the birthday hasn't occurred yet this year
                    if (
                        monthDifference < 0 ||
                        (monthDifference === 0 && today.getDate() < birthDate.getDate())
                    ) {
                        age--;
                    }

                    return age;
                }

                this.groupBookExportList(this.filterBookDeliveryList).forEach((row, index) => {
                    let columnX = margin_l;
                    const txtId = row.mpStudentId ? row.mpStudentId.toString() : '-';
                    const studentName = row.memberName ?? '-';
                    const txtPhone = row.msaPhone ? row.msaPhone.toString() : '-';
                    const isVerify = row.mpAdminApproveAt ? 'ยืนยันแล้ว' : 'ยังไม่ยืนยัน';
                    const txtPostalCode = row.msaPostcode ? row.msaPostcode.toString() : '-';
                    const txtBookId = row.bookCode ? row.bookCode.join("|") : '-';
                    const txtPurchaseId = row.coOrderNumber ? row.coOrderNumber.toString() : '-';
                    const purchaseDate = this.thaiDateFilter(row.coActualPurchaseDateTime);
                    let age = row.mpDateOfBirth ? calculateAge(row.mpDateOfBirth).toString() : '-';
                    let price = row.coPurchasePrice.length > 0 ? row.coPurchasePrice[0] : '0';
                    price = Number(price).toLocaleString('en-US');
                    const method = {
                        QRCODE: "QR Code",
                        ONLINEBANKING: "Online Banking",
                        CASH: "เงินสด",
                        CREDITCARD: "บัตรเครดิต",
                        TRANSFER: "เงินโอน"
                    };
                    let paymentMethod = method[row.coPaymentMethod] || "-";

                    // 1. Split long text into arrays of wrapped lines
                    const padding = 10;
                    const nameLines = pdf.splitTextToSize(studentName, colWidths[2] - padding);
                    const addressLines = pdf.splitTextToSize(this.getAddress(row), colWidths[6] - padding);
                    const booksLines = pdf.splitTextToSize(txtBookId, colWidths[8] - padding);
                    const paymentLines = pdf.splitTextToSize(paymentMethod, colWidths[11] - padding);

                    // 2. Calculate heights for individual text blocks
                    const fontHeight = pdf.getFontSize() * 0.3528;
                    const lineSpacing = 5;
                    const calculatedNameHeight = (nameLines.length * fontHeight) + ((nameLines.length - 1) * lineSpacing) + 10;
                    const calculatedAddressHeight = (addressLines.length * fontHeight) + ((addressLines.length - 1) * lineSpacing) + 10;
                    const calculatedBooksHeight = (booksLines.length * fontHeight) + ((booksLines.length - 1) * lineSpacing) + 10;
                    const calculatedPaymentHeight = (paymentLines.length * fontHeight) + ((paymentLines.length - 1) * lineSpacing) + 10;

                    // 3. Find the maximum height for the entire row
                    finalRowHeight = Math.max(cellHeight, calculatedNameHeight, calculatedAddressHeight, calculatedBooksHeight, calculatedPaymentHeight);

                    // ==========================================
                    // CRITICAL FIX: AUTOMATIC PAGE BREAK CHECK
                    // ==========================================
                    if (pdf_position_y + finalRowHeight > maxPrintableY) {
                        pdf.addPage();
                        pdf_position_y = margin_t; // Reset to the top of the new page

                        // RE-DRAW TABLE HEADERS ON THE NEW PAGE
                        headerX = margin_l;
                        renderTableHeader();
                    }
                    // ==========================================

                    // --- DRAW COLUMN 1: No. ---
                    pdf.rect(columnX, pdf_position_y, colWidths[0], finalRowHeight);
                    const idxText = (index + 1).toString();
                    const idxWidth = pdf.getStringUnitWidth(idxText) * pdf.getFontSize() / pdf.internal.scaleFactor;
                    this.thaitext(pdf, idxText, columnX + (colWidths[0] - idxWidth) / 2, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                    columnX += colWidths[0];

                    // --- DRAW COLUMN 2: Student ID ---
                    pdf.rect(columnX, pdf_position_y, colWidths[1], finalRowHeight);
                    this.thaitext(pdf, txtId, columnX + 5, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                    columnX += colWidths[1];

                    // --- DRAW COLUMN 3: Student Name (Wrapped) ---
                    pdf.rect(columnX, pdf_position_y, colWidths[2], finalRowHeight);
                    const totalNameHeight = (nameLines.length * fontHeight) + ((nameLines.length - 1) * lineSpacing);
                    let nameY = pdf_position_y + (finalRowHeight - totalNameHeight) / 2 + fontHeight;
                    nameLines.forEach((line) => {
                        this.thaitext(pdf, line, columnX + 5, nameY);
                        nameY += fontHeight + lineSpacing;
                    });
                    columnX += colWidths[2];

                    // --- DRAW COLUMN 4: Phone No. ---
                    pdf.rect(columnX, pdf_position_y, colWidths[3], finalRowHeight);
                    this.thaitext(pdf, txtPhone, columnX + 5, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                    columnX += colWidths[3];

                    // --- DRAW COLUMN 5: Age ---
                    pdf.rect(columnX, pdf_position_y, colWidths[4], finalRowHeight);
                    this.thaitext(pdf, age, columnX + 5, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                    columnX += colWidths[4];

                    // --- DRAW COLUMN 6: Verify ---
                    pdf.rect(columnX, pdf_position_y, colWidths[5], finalRowHeight);
                    this.thaitext(pdf, isVerify, columnX + 5, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                    columnX += colWidths[5];

                    // --- DRAW COLUMN 7: Address (Wrapped) ---
                    pdf.rect(columnX, pdf_position_y, colWidths[6], finalRowHeight);
                    const totalAddressHeight = (addressLines.length * fontHeight) + ((addressLines.length - 1) * lineSpacing);
                    let addressY = pdf_position_y + (finalRowHeight - totalAddressHeight) / 2 + fontHeight;
                    addressLines.forEach((line) => {
                        this.thaitext(pdf, line, columnX + 5, addressY);
                        addressY += fontHeight + lineSpacing;
                    });
                    columnX += colWidths[6];

                    // --- DRAW COLUMN 8: Postal code ---
                    pdf.rect(columnX, pdf_position_y, colWidths[7], finalRowHeight);
                    this.thaitext(pdf, txtPostalCode, columnX + 5, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                    columnX += colWidths[7];

                    // --- DRAW COLUMN 9: Book id ---
                    pdf.rect(columnX, pdf_position_y, colWidths[8], finalRowHeight);
                    const totalBooksHeight = (booksLines.length * fontHeight) + ((booksLines.length - 1) * lineSpacing);
                    let booksY = pdf_position_y + (finalRowHeight - totalBooksHeight) / 2 + fontHeight;
                    booksLines.forEach((line) => {
                        this.thaitext(pdf, line, columnX + 5, booksY);
                        booksY += fontHeight + lineSpacing;
                    });
                    columnX += colWidths[8];

                    // --- DRAW COLUMN 10: Purchase ID ---
                    pdf.rect(columnX, pdf_position_y, colWidths[9], finalRowHeight);
                    this.thaitext(pdf, txtPurchaseId, columnX + 5, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                    columnX += colWidths[9];

                    // --- DRAW COLUMN 11: Purchase date ---
                    pdf.rect(columnX, pdf_position_y, colWidths[10], finalRowHeight);
                    this.thaitext(pdf, purchaseDate, columnX + 5, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                    columnX += colWidths[10];

                    // --- DRAW COLUMN 12: Payment channels ---
                    pdf.rect(columnX, pdf_position_y, colWidths[11], finalRowHeight);
                    const totalPaymentHeight = (paymentLines.length * fontHeight) + ((paymentLines.length - 1) * lineSpacing);
                    let paymentY = pdf_position_y + (finalRowHeight - totalPaymentHeight) / 2 + fontHeight;
                    paymentLines.forEach((line) => {
                        this.thaitext(pdf, line, columnX + 5, paymentY);
                        paymentY += fontHeight + lineSpacing;
                    });
                    columnX += colWidths[11];

                    // --- DRAW COLUMN 13: Price ---
                    pdf.rect(columnX, pdf_position_y, colWidths[12], finalRowHeight);
                    this.thaitext(pdf, price, columnX + 5, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                    columnX += colWidths[12];

                    // 4. Move Y down cleanly by the shared unified row height
                    pdf_position_y += finalRowHeight;
                });

                // ==========================================
                // DRAW THE TOTAL SUMMARY ROW
                // ==========================================

                // 1. Calculate total sum dynamically from your list
                finalRowHeight = 20;
                const totalBooks = this.bookDeliveryList.length;
                const totalPrice = this.groupBookExportList(this.bookDeliveryList).reduce((sum, row) => sum + (Number(row.coPurchasePrice[0]) || 0), 0);

                // 2. Check if there is enough space on the current page for the summary row
                if (pdf_position_y + finalRowHeight > maxPrintableY) {
                    pdf.addPage();
                    pdf_position_y = margin_t; // Reset to top if it overflows
                }

                // 3. Set the font style to Bold for the summary row
                pdf.setFont("Sarabun", "bold");

                let currentX = margin_l;

                // Combine widths of Column 1, 2, and 3 for the text "รวมทั้งหมด"
                const spanWidth = colWidths.reduce(
                    (accumulator, currentValue) => accumulator + currentValue,
                    0,
                );
                const totalBookSpanWidth = colWidths.slice(0, 8).reduce((acc, current) => acc + current, 0);
                const totalPriceSpanWidth = colWidths.slice(8, 12).reduce((acc, current) => acc + current, 0);

                // Total Books
                // Draw the rectangle background for the spanned section (optional grey background like the image)
                pdf.setFillColor(240, 240, 240); // Light grey color
                pdf.rect(currentX, pdf_position_y, spanWidth, finalRowHeight, 'F'); // Fill background
                pdf.rect(currentX, pdf_position_y, spanWidth, finalRowHeight, 'S'); // Draw border stroke

                // Calculate text width for right alignment with a small padding (e.g., 15 units from the right edge)
                const totalBookLabelText = "จำนวนหนังสือทั้งหมด";
                let labelWidth = pdf.getStringUnitWidth(totalBookLabelText) * pdf.getFontSize() / pdf.internal.scaleFactor;
                let labelX = currentX + totalBookSpanWidth - labelWidth - 15;
                let labelY = pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight;

                // Render "รวมทั้งหมด"
                this.thaitext(pdf, totalBookLabelText, labelX, labelY);

                // Move currentX to the 4th column (Course Count)
                currentX += totalBookSpanWidth;

                // 4. Draw Column 4: Total sum number box
                pdf.setFillColor(240, 240, 240);
                pdf.rect(currentX, pdf_position_y, colWidths[8], finalRowHeight, 'F');
                pdf.rect(currentX, pdf_position_y, colWidths[8], finalRowHeight, 'S');

                const totalBookText = totalBooks.toString();
                let totalWidth = pdf.getStringUnitWidth(totalBookText) * pdf.getFontSize() / pdf.internal.scaleFactor;
                // Center align the total number in the last column
                let totalX = currentX + (colWidths[8] - totalWidth) / 2;

                this.thaitext(pdf, totalBookText, totalX, labelY);

                // Total Price
                // Calculate text width for right alignment with a small padding (e.g., 15 units from the right edge)
                const totalPriceLabelText = "รวมเงิน";
                labelWidth = pdf.getStringUnitWidth(totalPriceLabelText) * pdf.getFontSize() / pdf.internal.scaleFactor;
                labelX = currentX + totalPriceSpanWidth - labelWidth - 15;
                labelY = pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight;

                // Render "รวมทั้งหมด"
                this.thaitext(pdf, totalPriceLabelText, labelX, labelY);

                // Move currentX to the 4th column (Course Count)
                currentX += totalPriceSpanWidth;

                // 4. Draw Column 4: Total sum number box
                pdf.setFillColor(240, 240, 240);
                pdf.rect(currentX, pdf_position_y, colWidths[12], finalRowHeight, 'F');
                pdf.rect(currentX, pdf_position_y, colWidths[12], finalRowHeight, 'S');

                const totalPriceText = totalPrice.toLocaleString('en-US');
                totalWidth = pdf.getStringUnitWidth(totalPriceText) * pdf.getFontSize() / pdf.internal.scaleFactor;
                // Center align the total number in the last column
                totalX = currentX + (colWidths[12] - totalWidth) / 2;

                this.thaitext(pdf, totalPriceText, totalX, labelY);

                pdf_position_y += finalRowHeight;

                // =========================================================================
                // DRAW PAGE NUMBERS (ALWAYS PLACE AT THE VERY END OF YOUR SCRIPT)
                // =========================================================================

                const totalPages = pdf.internal.getNumberOfPages();

                pdf.setFont("Sarabun", "normal");
                pdf.setFontSize(this.pdfConfig.typo.extraSmall);

                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i);

                    // Render top-right page counter
                    this.thaitext(
                        pdf,
                        `${i} / ${totalPages}`,
                        pdf_width - 20,
                        20,
                        0,
                        "right"
                    );
                }

                setTimeout(() => {
                    pdf.save("รายงานเพื่อจัดส่งหนังสือ.pdf");
                }, 0);
                this.isDisableDownloadReportBtn = false;
            } catch (error) {
                console.log(error)
            }
        }
    }
}